import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Input, Card, Form, Typography } from 'antd'
import 'antd/dist/antd.css'
import ConfirmHandler from '../../utils/ConfirmHandler'
import ErrorHandler from '../../utils/ErrorHandler'
import ButtonMain from '../../components/ButtonMain/ButtonMain.jsx'
import { GetRegisterVerify, GetResendRegisterVerify, GetRegisterAuthorize } from '../../api/Register'
import { ForgetPassword, ForgetPasswordVerify, ResendForgetPasswordVerify } from '../../api/ForgetPassword'
import Loading from '../../components/Loading/Loading.jsx'
import './MessageVerify.scss'

const { Title } = Typography

export default function NewsletterVerify () {
  const [finishInputPhoneNumber, setFinishInputPhoneNumber] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [confirmModalMsg, setConfirmModalMsg] = useState('')
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  const history = useHistory()
  useEffect(() => {
    if (params === '/forgetPassword') {
      setFinishInputPhoneNumber(false)
    }
    if (params === '/register/smsverification') {
      setFinishInputPhoneNumber(true)
    }
  }, [])
  const handleOk = () => {
    setIsModalVisible(false)
    if (params === '/register/smsverification') {
      const memberAccessToken = sessionStorage.getItem('member_access_token')
      if (memberAccessToken) {
        fetchRegisterAuthorizeData()
      }
    }
  }
  const urlSearchParams = new URLSearchParams(window.location)
  const params = Object.fromEntries(urlSearchParams.entries()).pathname
  const VerifyMethod = async () => {
    form.validateFields()
      .then(fetchData)
      .catch(error => {
        const { errorFields } = error
        const filterErrorMsg = errorFields.map(item => {
          const { errors } = item
          item.errors = [...new Set(errors)]
          return item
        })
        setIsErrorModalVisible(filterErrorMsg)
      })
  }
  async function fetchRegisterAuthorizeData () {
    setIsLoading(true)
    const resp = await GetRegisterAuthorize()
    setIsLoading(false)
    if (resp.rcrm.RC === 'C01') {
      location.replace(`${resp.results.location}`)
    } else {
      setIsModalVisible(true)
      setConfirmModalMsg(`${resp.rcrm.RM}`)
    }
  }
  async function fetchData (values) {
    const TempAccessToken = sessionStorage.getItem('TEMP_ACCESS_TOKEN')
    setIsLoading(true)
    const Verify = await GetRegisterVerify({ formValue: values.SMS_verification_code, tempAccessToken: TempAccessToken })
    setIsLoading(false)
    if (Verify.rcrm.RC === 'C01') {
      sessionStorage.setItem('member_access_token', Verify.results.member_access_token)
    }

    setIsModalVisible(true)
    setConfirmModalMsg(`${Verify.rcrm.RM}`)
  }
  const ResendVerify = async () => {
    const TempAccessToken = sessionStorage.getItem('TEMP_ACCESS_TOKEN')
    setIsLoading(true)
    await GetResendRegisterVerify({ tempAccessToken: TempAccessToken })
    setIsLoading(false)
  }

  const Forgetpassword = async () => {
    form.validateFields()
      .then(fetchForgetData)
      .catch(error => {
        const { errorFields } = error
        const filterErrorMsg = errorFields.map(item => {
          const { errors } = item
          item.errors = [...new Set(errors)]
          return item
        })
        setIsErrorModalVisible(filterErrorMsg)
      })
  }
  async function fetchForgetData (values) {
    setIsLoading(true)
    const Forget = await ForgetPassword(values)
    setIsLoading(false)
    if (Forget.rcrm.RC === 'C01') {
      sessionStorage.setItem('TEMP_ACCESS_TOKEN', Forget.results.temp_access_token)
      setFinishInputPhoneNumber(true)
    } else {
      const { rcrm } = Forget
      setIsModalVisible(true)
      switch (rcrm.RC) {
        case 'MEMBER_IS_NOT_EXIST':
          setConfirmModalMsg('會員帳號輸入錯誤')
          break
        case 'MEMBER_BIRTHDAY_NOT_CORRECT':
          setConfirmModalMsg('會員生日輸入資料錯誤')
          break
        default:
          setConfirmModalMsg('系統執行有誤，請重新再試一次，謝謝。')
          break
      }
    }
  }

  const ForgetpasswordVerify = async () => {
    form.validateFields()
      .then(fetchForgetVerifyData)
  }
  async function fetchForgetVerifyData (values) {
    if (!values.SMS_verification_code) {
      const errorMsg = [{ errors: ['簡訊驗證碼為必填'] }]
      const filterErrorMsg = errorMsg.map(item => {
        const { errors } = item
        item.errors = [...new Set(errors)]
        return item
      })
      setIsErrorModalVisible(filterErrorMsg)
    }
    const TempAccessToken = sessionStorage.getItem('TEMP_ACCESS_TOKEN')
    setIsLoading(true)
    const ForgetVerify = await ForgetPasswordVerify({ formValue: values.SMS_verification_code, tempAccessToken: TempAccessToken })
    setIsLoading(false)
    if (ForgetVerify.rcrm.RC === 'C01') {
      history.push('/forgetPassword/resetPassword')
    }
  }
  const ForgetPasswordVerifyResend = async () => {
    form.validateFields()
      .then(async () => {
        const TempAccessToken = sessionStorage.getItem('TEMP_ACCESS_TOKEN')
        setIsLoading(true)
        await ResendForgetPasswordVerify({ tempAccessToken: TempAccessToken })
        setIsLoading(false)
      })
  }

  return (
    <>
      <Card type="inner" className="loginPage-basic">
        <div className="input-basic">
          {
            finishInputPhoneNumber
              ? <Title level={2} className="page-title">請輸入手機簡訊驗證碼</Title>
              : <Title level={2} className="page-title">請輸入您的註冊會員手機號碼</Title>
          }
        </div>
        {isErrorModalVisible ? <ErrorHandler errorList={isErrorModalVisible} /> : null}
        <Form
          form={form}
          name="basic"
          autoComplete="off"
        >
          {
            finishInputPhoneNumber
              ? <Form.Item
                label="簡訊驗證碼"
                name="SMS_verification_code"
              >
                <Input className="input-text" placeholder="請輸入驗證碼" />
              </Form.Item>
              : <>
              <Form.Item
                label="會員手機號碼"
                name="Member_mobile_number"
                rules={[
                  {
                    required: true,
                    message: '會員手機號碼為必填'
                  },
                  {
                    len: 10,
                    message: '會員手機號碼格式錯誤'
                  }
                ]}
              >
                <Input className="input-text" placeholder="請輸入註冊的手機號碼" />
              </Form.Item>
              </>
          }

          {
            finishInputPhoneNumber
              ? <>
                  <ButtonMain buttonType="main" onClick={params === '/register/smsverification' ? VerifyMethod : ForgetpasswordVerify}>驗證</ButtonMain>
                  <ButtonMain buttonType="second" onClick={params === '/register/smsverification' ? ResendVerify : ForgetPasswordVerifyResend}>重新寄送驗證碼</ButtonMain>
                </>
              : <>
                  <ButtonMain buttonType="main" onClick={Forgetpassword}>確定</ButtonMain>
                </>
          }
        </Form>
      </Card>
      <Card
        type="inner"
        className="container-link"
      >
        {
          finishInputPhoneNumber
            ? <><p className="text-link">
              已寄送驗證碼至{form.getFieldValue('Member_mobile_number') || sessionStorage.getItem('Member_mobile_number')}，若您未收到驗證碼，請點擊「重新寄送驗證碼」。
            </p></>
            : <><p className="text-link">
              我們將寄送簡訊驗證碼置您註冊使用的手機號碼，驗證後將引導您重新設定密碼。
            </p>
            </>
        }
      </Card>
      <Loading isLoadingVisible={isLoading}></Loading>
      {isModalVisible ? <ConfirmHandler title="提示" setModalvisible={isModalVisible} setHandleOk={handleOk} msg={confirmModalMsg}/> : null}
    </>
  )
}
